<template>
    <div class="content_box mobile_content">
        <div class="content overview ">
            <div class="top el_form mobile_form">
                <div class="title">
                    <span>总览</span> &nbsp;&nbsp;
                </div>
                <el-select v-model="product_id" size="medium" placeholder="请选择">
                    <el-option :label="item.product_name" :value="item.product_id" v-for="item in product" :key="item.product_id + '123'"></el-option>
                </el-select>
            </div>
            <div class="time_box">
                <van-tabs v-model="timeTab" line-height="0px" title-inactive-color="#868998" title-active-color="#fff" background="none">
                    <van-tab title="昨天" name="1"></van-tab>
                    <van-tab title="最近7天" name="7"></van-tab>
                    <van-tab title="最近30天" name="30"></van-tab>
                    <van-tab title="自定义" name="customize"></van-tab>
                </van-tabs>
                <div class="customize_date" v-show="timeTab == 'customize'">
                    <DatePicker :date="overviewTime" @dateSelect="dateSelect"></DatePicker>
                </div>
            </div>
            <div class="area_box order_number_box">
                <div class="order_number">
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/create.png" alt="">
                        <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，新创建的工单量" placement="bottom-start">
                            <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                        </el-tooltip>
                        <p class="number_box">
                            <span class="number">{{formatNumber(orderData.create_count || 0)}}</span>
                        </p>
                        <p class="name">
                            <span>新建工单量</span>
                        </p>
                    </div>
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/assignee.png" alt="">
                        <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，状态为“受理中”的工单量" placement="bottom-start">
                            <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                        </el-tooltip>
                        <p class="number_box">
                            <span class="number2">{{formatNumber(orderData.run_count || 0)}}</span>
                        </p>
                        <p class="name">
                            <span>受理中工单量</span> 
                        </p>
                    </div>
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/end.png" alt="">
                        <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，已完结的工单量" placement="bottom-start">
                            <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                        </el-tooltip>
                        <div class="number_box">
                            <span class="number3">{{formatNumber(orderData.end_count || 0)}}</span>
                            <p class="percentage">{{'完结率' + (orderData.create_count ? (orderData.end_count/orderData.create_count * 100).toFixed(2) + '%' : '0%')}}</p>
                        </div>
                        <p class="name">
                            <span>已完结工单量</span>
                        </p>
                    </div>
                    <div class="order_number_item">
                        <img class="order_img" src="../../../assets/images/overview/record.png" alt="">
                        <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                            <div slot="content">
                                <el-form label-position="left" label-width="120px">
                                    <el-form-item label="售后登记工单量">
                                        <span>筛选时间内，新建工单中有售后登记（退货/换货/补发配件/维修）的工单数量</span>
                                    </el-form-item>
                                    <el-form-item label="登记率">
                                        <span>售后登记工单量/新建工单量</span>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                        </el-tooltip>
                        <div class="number_box">
                            <span class="number3">{{formatNumber(orderData.after_count || 0)}}</span>
                            <p class="percentage">{{'登记率 ' + (orderData.after_rate ? (orderData.after_rate) : '0%')}}</p>
                        </div>
                        <p class="name">
                            <span>售后登记工单量</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="area_box pie_area_box">
                <div class="order_problem">
                    <div class="pie">
                        <div class="source block_area">
                            <div class="title subtitle">工单问题责任方占比</div>
                            <div class="pie_area data_area">
                                <div class="pie_box" ref="sourcePie" >
                                </div>
                                <div class="dataNone pie_none" v-show="!this.orderData.source_num || this.orderData.source_num.length == 0">暂无数据</div>
                            </div>
                        </div>
                        <div class="model block_area">
                            <div class="title subtitle">产品型号占比</div>
                            <div class="pie_area data_area">
                                <div class="pie_box" ref="modelPie" >
                                </div>
                                <div class="dataNone pie_none" v-show="!this.orderData.type_num || this.orderData.type_num.length == 0">暂无数据</div>
                            </div>
                        </div>
                        <div class="afterSale block_area">
                            <div class="title subtitle">售后方式占比</div>
                            <div class="pie_area data_area">
                                <div class="pie_box" ref="afterSalePie" >
                                </div>
                                <div class="dataNone pie_none" v-show="!this.orderData.after_name || this.orderData.after_name.length == 0">暂无数据</div>
                            </div>
                            
                        </div>
                        <div class="register block_area">
                            <div class="title subtitle">售后登记工单产品型号占比</div>
                            <div class="pie_area data_area">
                                <div class="pie_box" ref="registerPie" >
                                </div>
                                <div class="dataNone pie_none" v-show="!this.orderData.after_type_name || this.orderData.after_type_name.length == 0">暂无数据</div>
                            </div>
                        </div>
                    </div>
                    <div class="leaderboard block_area">
                        <div class="title subtitle">
                            <span>工单问题分类排行top 10</span>
                            <el-select v-model="getWorkProblemData.product_type" clearable placeholder="全部型号">
                                <el-option :label="item" :value="item" v-for="item in productTypes" :key="item + '75745'"></el-option>
                            </el-select>
                        </div>
                        <div class="leaderboard_box data_area">
                            <div class="leaderboard_item" v-for="(item, i) in orderData.cate_names" :key="item + i + 214234">
                                <div class="label">
                                    <span class="serial" :class="'serial-' + (i+1)">{{i + 1}}</span>
                                    <span class="name ellipsis">{{item}}</span>
                                </div>
                                <span class="number">{{orderData.cate_num[i] || 43243}}</span>
                            </div>
                            <div class="dataNone leaderboard_none" v-show="!orderData.cate_names || orderData.cate_names.length == 0">暂无数据</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="area_box">
                <div class="trend_box block_area">
                    <div class="trend_top padding">
                        <div class="title">
                            <span>新建工单量和完结工单量趋势</span>
                            <el-tooltip popper-class="shadow" effect="light" content="筛选时间范围内，统计新建工单量和完结工单的趋势变化" placement="bottom-start">
                                <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                            </el-tooltip>
                        </div>
                        <div class="search_box">
                            <el-form label-position="left" label-width="80px">
                                <el-form-item label="统计指标">
                                    <el-radio-group v-model="trendType" size="mini">
                                        <el-radio-button  label="create">新建工单量</el-radio-button>
                                        <el-radio-button label="end">完结工单量</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="日期选择">
                                    <DatePicker :date="trendTime" @dateSelect="trendTimeSelect"></DatePicker>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="padding line_echart">
                            <div class="select_show_type">
                                <el-radio-group v-model="getTrendData.data_type" size="mini">
                                    <el-radio-button label="TypeDay">日</el-radio-button>
                                    <el-radio-button label="TypeWeek" :disabled="!(selectType > 1)">周</el-radio-button>
                                    <el-radio-button label="TypeMonth" :disabled="!(selectType > 2)">月</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="echart_line_area data_area">
                                <div class="line_box" ref="line_echart">

                                </div>
                                <div class="dataNone pie_none line_none" v-show="!this.trendData.keyList || this.trendData.keyList.length == 0">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="area_box">
                <div class="trend_table">
                    <div class="title subtitle">
                        <span>数据明细</span>
                    </div>
                    <el-table
                        :data="trendTableData" highlight-current-row>
                        <el-table-column prop="date" label="日期" ></el-table-column>
                        <el-table-column prop="create" label="新建工单量" ></el-table-column>
                        <el-table-column prop="end" label="完结工单量" ></el-table-column>
                    </el-table>
                    <Pagination :total="total" :page="page" @paginationChange="initTableData"></Pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default({
    name: 'overview-mobile',
    data() {
        return {
            product_id:'',
            product: [],
            productTypes: [],
            timeTab: '7',
            overviewTime: [],
            getWorkProblemData: {
                start_time: 0,
                end_time: 0,
                product_type: ''
            },
            orderData: {},
            getTrendData: {
                start_time: 0,
                end_time: 0,
                data_type: 'TypeDay',
                zone: this.timezone
            },
            selectType: 3,
            trendData: {},
            trendType: 'create',
            trendTime: [],
            trendTableData: [],
            page_size: 10,
            page: 1,
            total: 0,
        }
    },
    watch: {
        timeTab: function(nT) {
            if(nT != 'customize') {
                this.overviewTime = this.setDate(parseInt(nT));
            }
        },
        'overviewTime' : function (nTime) {
            this.getWorkProblemData.start_time = nTime[0];
            this.getWorkProblemData.end_time = nTime[1];
            if(this.getWorkProblemData.product_id && nTime[0] && nTime[1]) {
                this.getWorkProblem();
            }
        },
        'trendTime' : function (nTime, oTime) {
            if(nTime[1] - nTime[0] < 86400000) { //选择同一天
                this.trendTime = [this.getTrendData.start_time, this.getTrendData.end_time];
                return;
            }
            if(nTime[1] - nTime[0] > 86400000 * 120) {  //最多可选120天
                this.trendTime = [this.getTrendData.start_time, this.getTrendData.end_time];
                this.$message.warning('最多可选择120天！');
                return;
            }
            if(nTime[1] - nTime[0] < 86400000 * 7) { //选择7天内 
                this.selectType = 1;
                this.getTrendData.data_type = 'TypeDay';
            }else if(nTime[1] - nTime[0] < 86400000 * 30) { //选择30天内 
                this.selectType = 2;
                if(this.getTrendData.data_type == 'TypeMonth') {
                    this.getTrendData.data_type = 'TypeWeek';
                }
            }else{
                this.selectType = 3;
            }

            this.getTrendData.start_time = nTime[0];
            this.getTrendData.end_time = nTime[1];
            if(this.getTrendData.product_id) {
                this.getOrderNumber();
            }
        },
        product_id: function(nId) {
            this.product.forEach(item => {
                if(item.product_id == nId){
                    this.productTypes = item.productTypes;
                    return;
                }
            })
            this.getWorkProblem();
            this.getOrderNumber();
        },
        trendType: function() {
            this.initLine();
        },
        'getTrendData.data_type': function() {
            this.getOrderNumber();
        },
        'getWorkProblemData.product_type': function() {
            this.getWorkProblem();
        }
    },
    created() {
        this.getProductCate();
    },
    methods: {
        setDate(day) {
            const date = new Date();
            const end = date.getTime() - (date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds() + 1) * 1000 - date.getMilliseconds();
            const start = end - 3600 * 1000 * 24 * day + 1000;
            return [start, end];
        },
        dateSelect(date) {
            this.overviewTime = [...date];
        },
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.product = data.data.productCateInfos;
                if(this.product.length > 0) {
                    this.product_id = this.product[0].product_id;
                }
                this.overviewTime = this.setDate(7);
                this.trendTime = this.setDate(30);
            })
        },
        getWorkProblem() {
            this.getWorkProblemData.product_id = this.product_id;
            this.api.getWorkProblem(this.getWorkProblemData).then(data => {
                this.orderData = data.data;
                this.initPie();
            })
        },
        trendTimeSelect(date) {
            this.trendTime = [...date];
        },
        getOrderNumber() {
            this.getTrendData.product_id = this.product_id;
            this.api.getOrderNumber(this.getTrendData).then(data => {
                this.trendData = data.data;
                this.total = data.data.createList.length;
                this.initLine();
                this.initTableData({page_size: this.page_size, page: 1});
            })
        },
        initPie() {
            let sourceTotal = 0, modelTotal = 0, afterSaleTotal = 0, registerTotal = 0;
            let sourceData = [], modelData = [], afterSaleData = [], registerData = [];
            for(let i=0; i< this.orderData.source_num.length; i++) {
                sourceData.push({value: this.orderData.source_num[i], name: this.orderData.source_names[i], per: this.orderData.source_per[i]});
                sourceTotal += this.orderData.source_num[i];
            }
            for(let i=0; i< this.orderData.type_num.length; i++) {
                modelData.push({value: this.orderData.type_num[i], name: this.orderData.type_names[i], per: this.orderData.type_per[i]});
                modelTotal += this.orderData.type_num[i];
            }
            for(let i=0; i< this.orderData.after_num.length; i++) {
                afterSaleData.push({value: this.orderData.after_num[i], name: this.orderData.after_name[i], per: this.orderData.after_per[i]});
                afterSaleTotal += this.orderData.after_num[i];
            }
            for(let i=0; i< this.orderData.after_type_num.length; i++) {
                registerData.push({value: this.orderData.after_type_num[i], name: this.orderData.after_type_name[i], per: this.orderData.after_type_per[i]});
                registerTotal += this.orderData.after_type_num[i];
            }
            var sourceChart = this.echarts.init(this.$refs.sourcePie);
            sourceChart.clear();
            sourceChart.setOption(this.pieOption(sourceData, sourceTotal));

            var modelChart = this.echarts.init(this.$refs.modelPie);
            modelChart.clear();
            modelChart.setOption(this.pieOption(modelData, modelTotal));
            
            var afterSaleChart = this.echarts.init(this.$refs.afterSalePie);
            afterSaleChart.clear();
            afterSaleChart.setOption(this.pieOption(afterSaleData, afterSaleTotal));

            var registerChart = this.echarts.init(this.$refs.registerPie);
            registerChart.clear();
            registerChart.setOption(this.pieOption(registerData, registerTotal));
        },
        initTableData(data) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendData.keyList.length; i++) {
                this.trendTableData.push({
                    date: this.trendData.keyList[i],
                    create: this.trendData.createList[i],
                    end: this.trendData.endList[i],
                });
                if(this.trendTableData.length == data.page_size) break;
            }
        },
        initPie() {
            let sourceTotal = 0, modelTotal = 0, afterSaleTotal = 0, registerTotal = 0;
            let sourceData = [], modelData = [], afterSaleData = [], registerData = [];
            for(let i=0; i< this.orderData.source_num.length; i++) {
                sourceData.push({value: this.orderData.source_num[i], name: this.orderData.source_names[i], per: this.orderData.source_per[i]});
                sourceTotal += this.orderData.source_num[i];
            }
            for(let i=0; i< this.orderData.type_num.length; i++) {
                modelData.push({value: this.orderData.type_num[i], name: this.orderData.type_names[i], per: this.orderData.type_per[i]});
                modelTotal += this.orderData.type_num[i];
            }
            for(let i=0; i< this.orderData.after_num.length; i++) {
                afterSaleData.push({value: this.orderData.after_num[i], name: this.orderData.after_name[i], per: this.orderData.after_per[i]});
                afterSaleTotal += this.orderData.after_num[i];
            }
            for(let i=0; i< this.orderData.after_type_num.length; i++) {
                registerData.push({value: this.orderData.after_type_num[i], name: this.orderData.after_type_name[i], per: this.orderData.after_type_per[i]});
                registerTotal += this.orderData.after_type_num[i];
            }
            var sourceChart = this.echarts.init(this.$refs.sourcePie);
            sourceChart.clear();
            sourceChart.setOption(this.pieOption(sourceData, sourceTotal));

            var modelChart = this.echarts.init(this.$refs.modelPie);
            modelChart.clear();
            modelChart.setOption(this.pieOption(modelData, modelTotal));
            
            var afterSaleChart = this.echarts.init(this.$refs.afterSalePie);
            afterSaleChart.clear();
            afterSaleChart.setOption(this.pieOption(afterSaleData, afterSaleTotal));

            var registerChart = this.echarts.init(this.$refs.registerPie);
            registerChart.clear();
            registerChart.setOption(this.pieOption(registerData, registerTotal));
        },
        initLine() {
            var lineChart = this.echarts.init(this.$refs.line_echart);
            lineChart.setOption(this.lineOption());
        }, 
        pieOption(data, total) {
            return {
                title: {
                    text: `{name|总单数}\n{val|${total}}`,
                    top: '42%',
                    left: '34px',
                    textStyle: {
                        rich: {
                            name: {
                                fontSize: 14,
                                color: '#666',
                                lineHeight: '20',
                                align: 'center'
                            },
                            val: {
                                fontSize: 14,
                                color: '#000',
                                lineHeight: '20',
                                align: 'center'
                            }
                        }
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b0}: <br /> {d0} % '
                },
                legend: {
                    orient: 'vertical',
                    left: '130px',
                    top: 'center',
                    itemWidth: 12,
                    itemHeight: 12,
                    icon: "circle",
                    itemGap: 16,
                    selectedMode: false,
                    formatter: function (name) {
                        let legendData;
                        for(let i=0; i<data.length; i++) {
                            if(data[i].name == name) {
                                legendData = data[i];
                                break;
                            }
                        }
                        if(legendData) {
                            return `{name|${legendData.name.length > 6 ? legendData.name.substring(0,6) + '...' : legendData.name}} {per|${legendData.per} %} ${legendData.value}`;
                        }
                        return '';
                    },
                    textStyle: {
                        fontSize: 12,
                        rich: {
                            name: {
                                fontSize: 12,
                                width: 90,

                            },
                            per: {
                                width: 60
                            }
                        }
                    }
                },
                series: [
                    {
                        name: '工单问题责任方占比',
                        type: 'pie',
                        center: ['60px', 'center'],
                        radius: ['60px', '40px'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            // borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '20'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            };
        },
        lineOption() {
            let xData = [...this.trendData.keyList];
            xData.reverse();
            let yData = [...this.trendData[this.trendType + 'List']].reverse();
            return {
                grid: {
                    left: 20,
                    top: 40,
                    bottom: 10,
                    right: 20,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function(item, index) {
                            return item.split('~')[0]
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitNumber: 5,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    axisLine: {
                        show: false
                    }
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    backgroundColor: 'rgba(255,255,255,.9)',
                    orderWidth: 0,
                    textStyle: {
                        color: '#333'
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            type: 'solid',
                            color: 'rgba(200,200,200,.4)'
                        }
                    },
                    formatter: `{b} <br /> ${this.trendType == 'create' ? '新建工单量' : '完结工单量'}: {c}`,

                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            color: '#5192FF',
                            width: 1
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y:1,
                                x2: 0,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: '#FFFFFF' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#5192FF' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }
                    }
                ]
            }
        }
    }
})
</script>
<style lang="less" scoped>
    @import '../../../less/overview.less';
</style>



// WEBPACK FOOTER //
// src/view/order/overview/overview-mobile.vue